import type { UseQueryResult } from "@tanstack/react-query";
import { commonResourceDetails } from "~/domain/common";
import type { CommonResource } from "~/domain/common";
import type { ApiVersion, DeprecationPolicy } from "~/domain/versioning";
import { Card } from "../Card";
import type { ForeignResourceRenderer } from "../Table";
import { ResourceFields } from "./ResourceFields";

export interface HistoryCardProps {
  query: UseQueryResult<CommonResource>;
  apiVersion: ApiVersion;
  deprecationPolicy: DeprecationPolicy;
  renderForeignResource: ForeignResourceRenderer<"user">;
}

export function HistoryCard({
  query,
  apiVersion,
  deprecationPolicy,
  renderForeignResource,
}: HistoryCardProps) {
  return (
    <Card title="History">
      <ResourceFields
        query={query}
        fields={commonResourceDetails}
        apiVersion={apiVersion}
        deprecationPolicy={deprecationPolicy}
        renderForeignResource={renderForeignResource}
      />
    </Card>
  );
}
